import { ActivityTypeKey } from "@/constants/activity"
import { MatchDayType } from "@/types/activity"
import { REPORT_TYPE } from "@/app/report/common/constants"
import type { FilterPresetPeriodType, UpsertFilterPresetPayload } from "@/types/filterPreset"

/** 기간 옵션 */
export const PERIOD_OPTIONS: { value: FilterPresetPeriodType; labelKey: string }[] = [
  { value: "last7d", labelKey: "periodLast7d" },
  { value: "last14d", labelKey: "periodLast14d" },
  { value: "last30d", labelKey: "periodLast30d" },
  { value: "thisWeek", labelKey: "periodThisWeek" },
  { value: "thisMonth", labelKey: "periodThisMonth" },
  { value: "lastMonth", labelKey: "periodLastMonth" },
  { value: "custom", labelKey: "periodCustom" },
  { value: "allTime", labelKey: "periodAllTime" },
]

/** 액티비티 타입 옵션 */
export const ACTIVITY_TYPE_OPTIONS = [
  { value: ActivityTypeKey.training, labelKey: "training" },
  { value: ActivityTypeKey.league, labelKey: "league" },
  { value: ActivityTypeKey.cup, labelKey: "cup" },
  { value: ActivityTypeKey.friendlyMatch, labelKey: "friendlyMatch" },
  { value: ActivityTypeKey.rehab, labelKey: "rehab" },
  { value: ActivityTypeKey.etc, labelKey: "etc" },
]

/** 매치 데이 옵션 */
export const MATCH_DAY_OPTIONS = Object.values(MatchDayType)

/** 새 프리셋 기본값 */
export const DEFAULT_PRESET_PAYLOAD: UpsertFilterPresetPayload = {
  name: "",
  reportType: REPORT_TYPE.DAILY,
  idfTemplate: null,
  idfPdfTemplate: null,
  periodType: "last7d",
  activityTypes: [],
  seasonWeekIds: [],
  matchDayTypes: [],
  selectedPlayerIds: [],
}
